import { render, staticRenderFns } from "./Totals.vue?vue&type=template&id=a70bc9a0&scoped=true&"
import script from "./Totals.vue?vue&type=script&lang=js&"
export * from "./Totals.vue?vue&type=script&lang=js&"
import style0 from "./Totals.vue?vue&type=style&index=0&id=a70bc9a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70bc9a0",
  null
  
)

component.options.__file = "Totals.vue"
export default component.exports